import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from '~/utils/navigation';
import styled from 'styled-components';

import Icon, { ICON_UPLOAD_LINE } from '~/components/icon';
import ButtonWrapper from '~/components/misc/button-wrapper';
import IconChevronLinkClose from '~/components/misc/icon-close-link';
import { HeadWrapper, MainTitle, SubTitle } from '~/components/misc/section-head';
import { ROUTE_ACCOUNT, ROUTE_ACCOUNT_UPLOAD } from '~/components/router/constants';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from '~/components/sidebar';
import translate from '~/components/translation/translation-provider';
import { useCloseCurrentContext } from '~/hooks/use-close-context';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';

const Button = styled.button`
	text-align: center;
	white-space: nowrap;
	width: 100%;
	position: relative;
	padding: 14px 14px 13px;
	:first-of-type {
		margin-bottom: 1px;
	}
`;

const KYC = ({
	translations: {
		MOBILE_DEPOSIT_KYC_MESSAGE,
		MOBILE_DEPOSIT_KYC_MESSAGE_NOT_UPLOADED,
		MOBILE_DEPOSIT_UPLOAD_DOCS_CONFIRM_BUTTON,
		MOBILE_DEPOSIT_UPLOAD_DOCS_CLOSE_BUTTON
	},
	uploadDocuments,
	routeState,
	onCloseCB
}) => {
	const { screenMedium } = useSelector(state => state.browser.lessThan.medium);
	const router = useRouter();
	const closeCurrentContext = useCloseCurrentContext();
	const transformPath = useContextualPathTransformer();

	const onSubmit = useCallback(() => {
		if (routeState) {
			closeCurrentContext();
			// TODO (navigation) - use search params or redux for state
			return router.push(transformPath(ROUTE_ACCOUNT_UPLOAD, routeState));
		}
		router.replace(transformPath(ROUTE_ACCOUNT_UPLOAD));
	}, [closeCurrentContext, router, routeState, transformPath]);

	const onCancel = useCallback(() => {
		if (routeState) {
			return closeCurrentContext();
		}

		router.replace(transformPath(ROUTE_ACCOUNT));
	}, [closeCurrentContext, router, routeState, transformPath]);

	const onClose = useCallback(() => {
		if (onCloseCB) {
			return onCloseCB();
		}

		onCancel();
	}, [onCancel, onCloseCB]);

	return (
		<Sidebar className={`modal-view bwi-modal ${screenMedium ? 'modal-view--mobile' : ''}`}>
			<>
				<SidebarHeader
					transparent={!screenMedium}
					Icon={<IconChevronLinkClose onClick={onClose} className="js-back page-head__back u-show" />}
				>
					<div className="page-head__right-side" />
				</SidebarHeader>
				<SidebarContent>
					<HeadWrapper>
						<Icon type={ICON_UPLOAD_LINE} />
						<MainTitle>{MOBILE_DEPOSIT_KYC_MESSAGE_NOT_UPLOADED}</MainTitle>
						<SubTitle>{MOBILE_DEPOSIT_KYC_MESSAGE}</SubTitle>
						<div id="confirm-modal-list-impl" className="confirm-modal-list u-pl1 u-pr1 u-text-l">
							<ul className="link-list link-list--flip-colors">
								{uploadDocuments?.map(value => (
									<li
										key={value}
										id="confirm-modal-list-item-template"
										className="link-list__item u-p1"
									>
										{value}
									</li>
								))}
							</ul>
						</div>
					</HeadWrapper>
				</SidebarContent>
				<SidebarFooter>
					<ButtonWrapper transparent={!screenMedium} smallerPositionValue="" biggerPositionValue="">
						<Button
							type="button"
							onClick={onSubmit}
							className="btn btn-send-mail btn-border-radius"
							data-at="deposit-upload-document-button"
						>
							{MOBILE_DEPOSIT_UPLOAD_DOCS_CONFIRM_BUTTON}
						</Button>
						<Button
							type="button"
							onClick={onCancel}
							className="js-close-button btn btn--secondary"
							data-at="close-upload-document-button"
						>
							{MOBILE_DEPOSIT_UPLOAD_DOCS_CLOSE_BUTTON}
						</Button>
					</ButtonWrapper>
				</SidebarFooter>
			</>
		</Sidebar>
	);
};
const kycTextKeys = [
	'MOBILE_DEPOSIT_KYC_MESSAGE',
	'MOBILE_DEPOSIT_KYC_MESSAGE_NOT_UPLOADED',
	'MOBILE_DEPOSIT_UPLOAD_DOCS_CONFIRM_BUTTON',
	'MOBILE_DEPOSIT_UPLOAD_DOCS_CLOSE_BUTTON'
];

export default translate(KYC, kycTextKeys);
